import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseNotesStepsWorker } from '../workers/notes.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseNotesSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseNotesStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseNotesStepsWorker | Remote<WarehouseNotesStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/notes.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseNotesStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseNotesStepsWorker()];
  }
}

export class WarehousePushNotesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_NOT_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing push notes sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseNotesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseDownloadNotesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_NOT_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download notes sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseNotesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanNotesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_NOT_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean notes sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseNotesSyncWorkerFactory(), taskBreaker);
  }
}
